import { type KeyValueStore } from './KeyValueStore'

const data: Record<string, Record<string, any>> = Object.create(null)

export class MemoryKeyValueStore<T> implements KeyValueStore<T> {
  private storeName: string

  constructor(storeName: string) {
    storeName = storeName.trim()

    if (storeName === '') {
      throw new TypeError('"storeName" should not be empty')
    }

    this.storeName = storeName
  }

  private initStore(): void {
    data[this.storeName] = Object.create(null)
  }

  private get store(): Record<string, T> {
    if (data[this.storeName] == null) {
      this.initStore()
    }

    return data[this.storeName]
  }

  async get(key: string): Promise<T | undefined> {
    return this.store[key]
  }

  async set(key: string, value: T): Promise<void> {
    this.store[key] = value
  }

  async remove(key: string): Promise<void> {
    delete this.store[key]
  }

  async keys(): Promise<Array<string>> {
    return Object.keys(this.store)
  }

  async values(): Promise<Array<T>> {
    return Object.values(this.store)
  }

  async entries(): Promise<Array<[string, T]>> {
    return Object.entries(this.store)
  }

  async clear(): Promise<void> {
    this.initStore()
  }

  async count(): Promise<number> {
    return Object.keys(this.store).length
  }
}
